/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFlag2Filled: {
  name: 'flag-2-filled';
  data: string;
} = {
  name: 'flag-2-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.28 2.146c-.055.011-2.755.631-6 1.378-4.75 1.094-5.951 1.384-6.16 1.484-.529.255-.972.835-1.077 1.409C4.013 6.582 4 8.869 4 13.9c0 8.135-.025 7.477.299 7.801a.984.984 0 0 0 1.402 0c.302-.302.299-.271.299-2.727v-2.171l.15-.039c.082-.022 2.697-.626 5.81-1.344 4.525-1.042 5.712-1.329 5.92-1.429a2.051 2.051 0 0 0 1.079-1.431c.031-.183.041-1.6.033-4.781l-.012-4.521-.131-.266c-.162-.329-.481-.633-.784-.747-.223-.083-.612-.132-.785-.099"/></svg>`
};
